export const convertToFahrenheit = (celsius) => {
  return (celsius * 9) / 5 + 32;
};
